import { createContext, useContext, useEffect, useState } from "react"
import { isAbortError } from "utils/errorHelpers"
import type { FeatureToggleType } from "utils/featureToggleManager"
import {
  featureToggleDefaultValues,
  FeatureToggleManager,
} from "utils/featureToggleManager"

const FeatureToggleContext = createContext<FeatureToggleType>(
  featureToggleDefaultValues
)

export const useFeatureToggle = () => useContext(FeatureToggleContext)

const FeatureToggleManagerProvider = (props: { children: React.ReactNode }) => {
  const [featureToggleConfig, setFeatureToggleConfig] =
    useState<FeatureToggleType>(featureToggleDefaultValues)

  useEffect(() => {
    FeatureToggleManager.init()
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setFeatureToggleConfig(FeatureToggleManager.getConfig())

    let isMounted = true

    const syncAll = async () => {
      try {
        await FeatureToggleManager.syncFromFirebase()
        // await FeatureToggleManager.syncFromPosthog()
        if (isMounted) {
          setFeatureToggleConfig(FeatureToggleManager.getConfig())
        }
      } catch (error: any) {
        // Silently handle abort errors when component unmounts
        if (!isAbortError(error)) {
          console.error("Failed to sync feature toggles:", error)
        }
      }
    }
    syncAll()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <FeatureToggleContext.Provider value={featureToggleConfig}>
      {props.children}
    </FeatureToggleContext.Provider>
  )
}

export default FeatureToggleManagerProvider
